<script setup>
  import ComponentBreadcrumb from "@components/Breadcrumb/Breadcrumb.vue";
  import PatientsPatientMasterData from "@pages/Patients/Components/PatientMasterData.vue";

  defineOptions({
    name: "PagesPatientCreate",
  });

  defineProps({
    patient: {
      type: Object,
      default: null,
    },
    continueWith: {
      type: String,
      default: null,
    },
  });
</script>

<template>
  <ComponentBreadcrumb
    class="mt-2"
    :links="[
      {
        label: 'Patienten',
        url: $route('patients.index'),
      },
      {
        label: 'Neuen Patienten anlegen',
      },
    ]"
  />

  <section>
    <div class="px-4 pt-4">
      <h2 class="text-2xl font-semibold">Neuer Patient</h2>
    </div>

    <article class="flex flex-col items-start space-y-6 p-4 lg:flex-row lg:space-y-0 lg:space-x-6">
      <div class="w-full space-y-6 lg:max-w-4xl">
        <PatientsPatientMasterData :continue-with="continueWith" />
      </div>
    </article>
  </section>
</template>
